import React, {useState} from "react";
import IconButton from "@material-ui/core/IconButton";
import {CheckRounded, PhotoCameraRounded} from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import {useSnackbar} from "notistack";
import {useHojasDeRutaService} from "../../../../services/hooks";

export const RemitoUploader = ({idPedido, idEntrega, onUpload = () => {}}) => {
  const [loading, setLoading] = useState(false);
  const [recibo, setRecibo] = useState(false);
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();
  const HojasDeRutaService = useHojasDeRutaService();

  const uploadInforme = event => {
    setLoading(true);

    // Paso los parámetros a un formData para poder enviar el archivo (remito)
    var formData = new FormData();
    formData.append('recibo', event.target.files[0]);
    // Limpio el input por si quieren subir varias veces.
    event.target.value = '';
    // formData.append('data', JSON.stringify(""));

    HojasDeRutaService.uploadRecibo(idPedido, idEntrega, formData,
      success => {
        onUpload();
        setRecibo(true);
        setLoading(false);
      },
      error => {
        setLoading(false);
        enqueueSnackbar(error, {variant: 'error'})
      }
    );
  }

  return (
    <>
      <input accept="image/*;capture=camera" className={'d-none'} id="recibo-file" type="file" onChange={uploadInforme}/>
      <label htmlFor="recibo-file">
        <div className={'position-relative'}>
          <IconButton color="primary" aria-label="upload picture" size={"medium"} component="span">
            {!recibo && <PhotoCameraRounded fontSize={"large"}/>}
            {recibo && <CheckRounded fontSize={"large"}/>}
          </IconButton>
          {loading && <CircularProgress size={50} style={{
            color: 'rgba(0, 121, 107, 0.8)',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -25,
            marginLeft: -25
          }}/>}
        </div>
      </label>
    </>
  )
}
